module.exports = __webpack_public_path__ + "img/s_and_l_cover_sample.628feb68.jpg";